import { Component, isValidElement } from 'react';

function isReactClass(obj) {
  return obj && obj.prototype && (obj.prototype.isReactComponent || obj.prototype instanceof Component);
}

function isReactComponent(obj) {
  return obj && (isReactClass(obj) || typeof obj === 'function');
}

export function isSetterConfig(obj) {
  return obj && typeof obj === 'object' && 'componentName' in obj && !isCustomView(obj);
}
export function isCustomView(obj) {
  return obj && ( /*#__PURE__*/isValidElement(obj) || isReactComponent(obj));
}
export function isDynamicSetter(obj) {
  return obj && typeof obj === 'function' && !isReactClass(obj);
}